export const RECEIVE_CONNECT_USER = 'RECEIVE_CONNECT_USER'
export const RECEIVE_DISCONNECT_USER = 'RECEIVE_DISCONNECT_USER'
export const RECEIVE_EDIT_STATE = 'RECEIVE_EDIT_STATE'

export const UPDATE_BOARD_EDIT_STATE = 'UPDATE_BOARD_EDIT_STATE'
export const UPDATE_LIST_EDIT_STATE = 'UPDATE_LIST_EDIT_STATE'
export const UPDATE_PLACE_EDIT_STATE = 'UPDATE_PLACE_EDIT_STATE'
export const CLEAR_EDIT_STATE = 'CLEAR_EDIT_STATE'
